import React from 'react';
import { AE_TITLE } from '@/components/assessment-engine/layout/aeTheme';
import type { AeBranding } from '@/types/assessmentEngine';

export interface TakeAssessmentCampaignTitleProps {
  campaignName?: string;
  branding?: AeBranding;
  /** Larger title on entry screens; compact on in-progress question pages. */
  size?: 'lg' | 'md';
}

/** Campaign + company header above the take-flow card; logo aligned right. */
export const TakeAssessmentCampaignTitle: React.FC<TakeAssessmentCampaignTitleProps> = ({
  campaignName,
  branding,
  size = 'lg',
}) => {
  const companyName = branding?.organization_display_name?.trim();
  const logoUrl = branding?.logo_url?.trim();

  if (!campaignName && !companyName && !logoUrl) return null;

  return (
    <div className="relative mb-6 flex min-h-[3rem] items-center">
      <div className={`flex-1 px-2 text-center ${logoUrl ? 'pr-36' : ''}`}>
        {campaignName && (
          <h1
            className={`${AE_TITLE} ${
              size === 'md' ? 'text-lg font-semibold' : 'text-2xl'
            }`}
          >
            {campaignName}
          </h1>
        )}
        {companyName && (
          <p className="mt-1 text-base font-normal text-[var(--color-surface-text)]">{companyName}</p>
        )}
      </div>
      {logoUrl && (
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center">
          <img
            src={logoUrl}
            alt={companyName ?? ''}
            className="h-10 max-w-[8rem] w-auto object-contain object-right"
          />
        </div>
      )}
    </div>
  );
};
